import React from 'react';

import BaseInput, { Props as BaseProps } from './BaseInput';

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement> & BaseProps,
  HTMLInputElement
>;

export const EmailInput = React.forwardRef<HTMLInputElement, Props>(
  ({ className, autoComplete, name, type, error, mask, ...props }, ref) => {
    return (
      <BaseInput
        ref={ref}
        type={type}
        name={name}
        mask={mask}
        error={error}
        className={className}
        autoComplete={autoComplete}
        {...props}
      />
    );
  }
);

export default EmailInput;
